import { Component, ElementRef, ViewChild } from '@angular/core';
import flatpickr from "flatpickr";
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-loading-overlay',
    template: `
        <div #flatpickrEl class="ag-input-text-wrapper custom-date-filter fa">
            <input type='text' data-input />
        </div>
    `,
    providers: [DatePipe]
})
export class CustomDateComponent {
    @ViewChild("flatpickrEl", { read: ElementRef, static: false }) flatpickrEl: ElementRef;
    private date;
    private params: any;
    private picker: any;

    constructor(private datePipe: DatePipe) { }

    agInit(params: any): void {
        this.params = params;
    }

    ngAfterViewInit(): void {
        this.picker = flatpickr(this.flatpickrEl.nativeElement, {
            onChange: this.onDateChanged.bind(this),
            wrap: true
        });
    }

    ngOnDestroy() {
    }

    onDateChanged(selectedDates) {
        this.date = this.datePipe.transform(selectedDates[0], 'dd-MM-yyyy HH:mm');
        this.params.api.stopEditing();
        this.params.api.setFocusedCell(this.params.node.rowIndex, this.params.column.colId)
    }

    getValue() {
        return this.date;
    }
}